import { withTranslation } from "react-i18next";
import TourTabs from './TourTabs';

export default withTranslation()(TourTabs);